// extracted by mini-css-extract-plugin
export default {"Container":"Products_Container__Lj4rj","Title":"Products_Title__lE895"};